import {createAction, handleActions} from 'redux-actions';
import {put, takeLatest} from 'redux-saga/effects';

import {finishLoading, startLoading} from '../loading';
import {createRequestActionTypes} from '../../api/createRequestSaga';
import {SERVER_URL} from '../../api/url';

// 액션 타입
const INITIALIZE = 'download/INITIALIZE';

const [DOWNLOAD_DOCS, DOWNLOAD_DOCS_SUCCESS, DOWNLOAD_DOCS_FAILURE] = createRequestActionTypes('download/DOWNLOAD_DOCS');

// 액션 생성 함수
export const initialize = createAction(INITIALIZE);

export const downloadDocs = createAction(
    DOWNLOAD_DOCS,
    ({ downloadLink }) => ({ downloadLink })
);

// 사가
function* downloadDocsSaga(action) {
    yield put(startLoading(DOWNLOAD_DOCS));

    try {
        const url = `${SERVER_URL}/uploads/${action.payload.downloadLink}`;

        let fileName = url.split('/'); // 파일명 추출
        fileName = fileName[fileName.length - 1];
                
        if (fileName.toLowerCase().endsWith('.pdf')) { // PDF 파일은 새 탭에서 열기
            window.open(url, '_blank');
        } else { // 기타 파일은 현재 탭에서 다운로드
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            a.setAttribute('download', fileName);
                    
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }
    } catch (e) {
        yield put({
            type: DOWNLOAD_DOCS_FAILURE,
            payload: e,
            error: true
        });
    }

    yield put(finishLoading(DOWNLOAD_DOCS));
}

export function* downloadSaga() {
    yield takeLatest(DOWNLOAD_DOCS, downloadDocsSaga);
};

// 상태
const initialState = {
    downloadResponse: null,
    downloadError: null
};

// 리듀서
const download = handleActions(
    {
        [INITIALIZE]: () => (initialState),
        [DOWNLOAD_DOCS_SUCCESS]: (state, { payload: response }) => ({
            ...state,
            downloadResponse: response.data,
            downloadError: null
        }),
        [DOWNLOAD_DOCS_FAILURE]: (state, { payload: error }) => ({
            ...state,
            downloadResponse: null,
            downloadError: error
        })
    },
    initialState
);

export default download;
